import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';

import withItemsFetcher from '@/hocs/withItemsFetcher';

import InlineSearch from './component';
import styles from './styles';

export default compose(withItemsFetcher, withStyles(styles))(InlineSearch);
